(function ($) {
  var $ = (jQuery = $)
  var $optTraditional = $('#opt-traditional')
  var $optPeelAndStick = $('#opt-peel-and-stick')
  var $optPrePasted = $('#opt-pre-pasted')
  var $calculatorForm = $('#CalculatorForm')
  // Modal-specific
  var $addToCartBtn = $("#VariantId")
  var $rollsNeeded = $("#RollsNeeded")
  var $variantTitle = $('#calcVariantTitle');
  var $wallpaperTypeOptions = $('input[name="wallpaper-type"]')

  if (!$calculatorForm.length) {
    return;
  }


  function getNumber(num) {
    return isNaN(num) || num.trim() === "" ? 0 : num
  }

  function handleize(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  }


  function addWall(e) {
    e.preventDefault()
    var $addButton = $(this)
    var $thisGroup = $addButton.closest(".js-calculator-input-group")
    var $nextGroup = $thisGroup.next()

    // Hide add/remove buttons from this wall after adding
    $addButton.addClass("is-hidden")
    $thisGroup.find(".js-remove-wall").addClass("is-hidden")

    // Show next wall group
    $nextGroup.addClass("is-visible")
  }

  function removeWall(e) {
    e.preventDefault()
    var $removeButton = $(this)
    var $thisGroup = $removeButton.closest(".js-calculator-input-group")
    var $prevGroup = $thisGroup.prev()

    // Empty inputs and hide this group
    $thisGroup.find("input").val("")
    $thisGroup.removeClass("is-visible")

    // Enable add/remove buttons in previous group
    $prevGroup.find(".js-add-wall").removeClass("is-hidden")
    $prevGroup.find(".js-remove-wall").removeClass("is-hidden")
  }

  function submitForm(e) {
    e.preventDefault()
    var fields = {}
    $.each($(this).serializeArray(), function (e, a) {
      fields[a.name] = a.value
    })

    var calc = new Calculator(fields),
      values = calc.validate()
    console.log("values:", values)

    values
      ? (console.log("Calculation: Success"), calc.calculate(values))
      : console.log("Calculation: Error.")
  }

  function addItemstoTheCart(items) {
    if(items) {
      var e = items.pop()
      console.log(e)
      $.ajax({
        url: "/cart/add",
        dataType: "json",
        type: "post",
        data: e,
        success: function () {
          addItemstoTheCart()
          $('body').trigger('added.ajaxProduct')
        },
        error: function () {
          console.error('Calculator error: Add to cart failed.')
          addItemstoTheCart()
        },
      })
    }
  }

  function addToCart(e) {
    e.preventDefault()
    
    var variant = parseInt($addToCartBtn.attr('data-variant'))
    var rollsNeeded = parseInt($rollsNeeded.text())
    var itemsToAdd = []

    itemsToAdd.push({
      id: variant,
      quantity: parseInt(rollsNeeded, 10) || 0,
    })
    
    console.log(variant, rollsNeeded, itemsToAdd)
    
    if(itemsToAdd) {
      addItemstoTheCart(itemsToAdd)
    } else {
      alert('No rolls to add to the cart. Be sure to calculate before adding.')
    }
  }

  function Calculator(fields) {
    if (!(this instanceof Calculator)) return new Calculator(fields)
    if (null == fields) {
      throw new Error("Calculator requires a config object")
    }
    this.fields = fields
  }

  Calculator.prototype.validate = function () {
    var errors = [],
      fields = this.fields,
      values = {}

    return (
      "" == fields.RoomHeightFeet || isNaN(fields.RoomHeightFeet)
        ? ($("#HeightError").text("Enter two valid numbers"),
          $("#HeightError").css("display", "block"),
          errors.push("error"))
        : ($("#HeightError").css("display", "none"),
          (values.height = {}),
          (values.height.feet = fields.RoomHeightFeet),
          (values.height.inches = getNumber(fields.RoomHeightInches))),
      $(".js-width-one").hasClass("is-visible") &&
        ("" == fields.RoomWidthFeetOne || isNaN(fields.RoomWidthFeetOne)
          ? ($("#WallErrorOne").text("Enter two valid numbers"),
            $("#WallErrorOne").css("display", "block"),
            errors.push("error"))
          : ($("#WallErrorOne").css("display", "none"),
            (values.wallOne = {}),
            (values.wallOne.feet = fields.RoomWidthFeetOne),
            (values.wallOne.inches = getNumber(fields.RoomWidthInchesOne)))),
      $(".js-width-two").hasClass("is-visible") &&
        ("" == fields.RoomWidthFeetTwo || isNaN(fields.RoomWidthFeetTwo)
          ? ($("#WallErrorTwo").text("Enter two valid numbers"),
            $("#WallErrorTwo").css("display", "block"),
            errors.push("error"))
          : ($("#WallErrorTwo").css("display", "none"),
            (values.wallTwo = {}),
            (values.wallTwo.feet = fields.RoomWidthFeetTwo),
            (values.wallTwo.inches = getNumber(fields.RoomWidthInchesTwo)))),
      $(".js-width-three").hasClass("is-visible") &&
        ("" == fields.RoomWidthFeetThree || isNaN(fields.RoomWidthFeetThree)
          ? ($("#WallErrorThree").text("Enter two valid numbers"),
            $("#WallErrorThree").css("display", "block"),
            errors.push("error"))
          : ($("#WallErrorThree").css("display", "none"),
            (values.wallThree = {}),
            (values.wallThree.feet = fields.RoomWidthFeetThree),
            (values.wallThree.inches = getNumber(
              fields.RoomWidthInchesThree
            )))),
      $(".js-width-four").hasClass("is-visible") &&
        ("" == fields.RoomWidthFeetFour || isNaN(fields.RoomWidthFeetFour)
          ? ($("#WallErrorFour").text("Enter two valid numbers"),
            $("#WallErrorFour").css("display", "block"),
            errors.push("error"))
          : ($("#WallErrorFour").css("display", "none"),
            (values.wallFour = {}),
            (values.wallFour.feet = fields.RoomWidthFeetFour),
            (values.wallFour.inches = getNumber(fields.RoomWidthInchesFour)))),
      !errors.length && values
    )
  }

  Calculator.prototype.calculate = function (values) {
    var result,
      heightInches =
        parseFloat(12 * values.height.feet) + parseFloat(values.height.inches),
      widthInches = 0,
      $selectedType = $('input[name="wallpaper-type"]:checked')[0],
      wallpaperMeasurement = $selectedType.value,
      wallpaperTypeName = $selectedType.id;

    values.wallOne &&
      (widthInches +=
        parseFloat(12 * values.wallOne.feet) +
        parseFloat(values.wallOne.inches))
    values.wallTwo &&
      (widthInches +=
        parseFloat(12 * values.wallTwo.feet) +
        parseFloat(values.wallTwo.inches))
    values.wallThree &&
      (widthInches +=
        parseFloat(12 * values.wallThree.feet) +
        parseFloat(values.wallThree.inches))
    values.wallFour &&
      (widthInches +=
        parseFloat(12 * values.wallFour.feet) +
        parseFloat(values.wallFour.inches))

    console.log("total height inches: " + heightInches)
    console.log("total width inches: " + widthInches)

    // Step One: Take width in inches and divide by the value of the wallpaper radio button
    const dividedWidth = widthInches / wallpaperMeasurement
    console.log(
      `width divided by ${wallpaperMeasurement} (${wallpaperTypeName})`,
      dividedWidth
    )

    // Step Two: Divide dividedWidth by 10, 5, 3, 2, or 1 depending on the height
    let heightBasedDiff = 1
    if (heightInches >= 1 && heightInches <= 35) {
      heightBasedDiff = 10
    } else if (heightInches >= 36 && heightInches <= 71) {
      heightBasedDiff = 5
    } else if (heightInches >= 72 && heightInches <= 107) {
      heightBasedDiff = 3
    } else if (heightInches >= 108 && heightInches <= 179) {
      heightBasedDiff = 2
    } else if (heightInches >= 180 && heightInches <= 360) {
      heightBasedDiff = 1
    }

    console.log("divided again by", heightBasedDiff)
    result = Math.ceil(dividedWidth / heightBasedDiff)

    console.log("final rolls: " + result)

    $rollsNeeded.text(result)
    $addToCartBtn.attr('disabled', false)
  }

  // Hide all materials when the variant changes
  // Find all non-sample variants that match the current color
  // Then show and select the appropriate option 
  function updateMaterialMeasurement(variant, allVariants) {
    var variantColor = variant.option1
    var variantTitle = variant.title

    $wallpaperTypeOptions.closest('.js-calc__options__item').hide()

    $.each(allVariants, function (index, item) {
      if(item.option1 === variantColor && !item.title.toLowerCase().includes('sample')) {
        if (item.name.toLowerCase().includes('traditional')) {
          $optTraditional.closest('.js-calc__options__item').show()
          if(item.title === variantTitle) {
            $optTraditional.attr('checked', true)
          }
        } else if (item.name.toLowerCase().includes('peel')) {
          $optPeelAndStick.closest('.js-calc__options__item').show()
          if (item.title === variantTitle) {
            $optPeelAndStick.attr('checked', true)
          }
        } else if (item.name.toLowerCase().includes('pre-pasted')) {
          $optPrePasted.closest('.js-calc__options__item').show()
          if (item.title === variantTitle) {
            $optPrePasted.attr('checked', true)
          }
        }
      }
    })
  }

  function getRollBySample(sample, allVariants) {
    // If the page loads with a sample, find the roll variant that matches the color and material and set that to currentVariant
    return $.grep(allVariants, function (item, index) {
      return sample.option1 === item.option1 && sample.option2 === item.option2 && item.title.toLowerCase().includes('roll')
    })
  }

  function updateModalSKU(variant) {
    // Add variant to addToCartBtn
    $addToCartBtn.attr('data-variant', variant.id)

    // Show variant title 
    $variantTitle.text(variant.title)

    // Reset result since it may have changed if the material is different
    $rollsNeeded.text('0')
    $addToCartBtn.attr('disabled', true)
  }

  //
  // Initialize
  //
  $(document).ready(function() {
    var sectionId = $('[data-section-type="product-template"]').attr('data-section-id')
    var currentVariant = sectionId ? JSON.parse($(`#CurrentVariantJson-${sectionId}`).text()) : null
    var allVariants = sectionId ? JSON.parse($(`#VariantsJson-${sectionId}`).text()) : null
    var isModal = $('.calculator-section').hasClass('is-modal')

    // 
    // BOTH CALCULATORS
    // 
    $calculatorForm.on("submit", submitForm)
    $(".js-add-wall").on("click", addWall)
    $(".js-remove-wall").on("click", removeWall)
    $addToCartBtn.on("click", addToCart)
    
    // Reset result since it may have changed if the material is different
    $wallpaperTypeOptions.on('change', function(event) {
      $rollsNeeded.text('0')
      $addToCartBtn.attr('disabled', true)

      // If it's in the product modal we'll want to update the add-to-cart ID accordingly
      if(isModal) {
        var currentVariantId = $addToCartBtn.attr('data-variant')
        var currentVariant = $.grep(allVariants, function(item, index) {
          return item.id === parseInt(currentVariantId)
        })
        var optionHandle = handleize(event.delegateTarget.id.replace('opt-', ''))
        var newVariant;
        
        if (currentVariant.length) {
          currentVariant = currentVariant[0]
          var currentColor = currentVariant.option1

          newVariant = $.grep(allVariants, function (item, index) {
            var handleizedTitle = handleize(item.title)
            return (item.option1 === currentColor) && handleizedTitle.includes(optionHandle) && !handleizedTitle.includes('sample')
          })
          if (newVariant.length) {
            updateModalSKU(newVariant[0])
          }
        }
      }
    })

    // 
    // PDP MODAL
    // 
    if(isModal) {
      var isSample = currentVariant.title.toLowerCase().includes('sample')


      if(isSample) {
        var rollVariantOfSample = getRollBySample(currentVariant, allVariants)
        if (rollVariantOfSample.length) {
          currentVariant = rollVariantOfSample[0]
        } else {
          // If there's no match, we'll return since this means something is off in the product variant order
          // and there won't be any safe fallbacks to assume
          return;
        }
      }

      if (currentVariant) {
        updateMaterialMeasurement(currentVariant, allVariants)
      }
  
      // Set variant on modal button so we know which measumrent to use and which product to add to cart.
      $(document).on('variant:change', function (event) {
        var variant = event.detail.variant;
        var isSample;
  
        if (!variant.id) {
          return;
        }

        isSample = variant.title.toLowerCase().includes('sample')

        if (isSample) {
          var rollVariantOfSample = getRollBySample(variant, allVariants)
          if (rollVariantOfSample.length) {
            variant = rollVariantOfSample[0]
          } else {
            // If there's no match, we'll return since this means something is off in the product variant order
            // and there won't be any safe fallbacks to assume
            return;
          }
        }
        
        // Update radio button
        updateMaterialMeasurement(variant, allVariants)
        updateModalSKU(variant)
      });
    }
  })
})(theme.jQuery);

